<template>
  <!-- name: '捐衣海报' -->
  <div class="certWrap">
    <GoBack :title="'捐衣海报'" />
    <van-loading v-show="isShowLoading">加载中...</van-loading>
    <img :src="imgUrl" alt="" style="margin-top:10px;width: 90%;" />
    <div class="cartBox" ref="cartHide">
      <img src="https://img.bbalt.cn/imgh5/other/poster_goods.jpg" alt="" class="bgImgClass" />
      <img :src="obj.headImage" alt="" class="headImgClass"  v-default-img="defaultImgUrl"/>
      <h4>{{ obj.nickName }}</h4>
      <div class="pBox">
        <p>预计将精准捐赠 {{ thingCount }} 件</p>
        <p>将帮助 {{ peopleCount }} 位</p>
      </div>
      <img src="https://img.bbalt.cn/imgh5/other/poster_footer.png" alt="" class="pointClass" />
      <img src="https://img.bbalt.cn/imgh5/other/poster_code_index.jpg" alt="" class="qrClass" />
    </div>

  </div>
</template>

<script>
import html2canvas from "html2canvas";
import GoBack from "@/components/GoBack";
import { userInfo } from "@/api/userCenter";
export default {
  components: { GoBack },
  data() {
    return {
      obj: {},
      thingCount: 1,
      peopleCount: 1,
      provincePoint: { x: 116, y: 280 },
      imgUrl: "",
      isShowLoading: true,
      defaultImgUrl: `https://img.bbalt.cn/imgh5/user_default.svg`,
    };
  },
  mounted() { },
  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const { content } = await userInfo();
      this.obj = content;
      let that = this;
      setTimeout(function () {
        that.makeCart();
      }, 1000);
    },
    makeCart() {
      let pointDom = document.querySelector(".pointClass");
      pointDom.style.left = this.provincePoint.x + "px";
      pointDom.style.top = this.provincePoint.y + "px";
      html2canvas(this.$refs.cartHide, {
        width: this.$refs.cartHide.width,
        height: this.$refs.cartHide.width,
        useCORS: true,
      }).then((canvas) => {
        console.log(canvas)
        this.imgUrl = canvas.toDataURL("image/png");
        this.isShowLoading = false
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.certWrap {
  height: 100%;
  width: 100%;
  background: linear-gradient(135deg, #fbf0f6, rgba(255, 255, 255, 0) 30%),
    linear-gradient(215deg, #e9f1f8, rgba(255, 255, 255, 0) 30%),
    linear-gradient(180deg, #fff, #fff 45%);
  overflow: hidden;
  display: flex;
  flex-flow: column;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  

  .cartBox {
    width: 597px;
    height: 945px;
    margin-top: 56px;
    // margin: 51px auto;
    text-align: center;
    color: #000;
    position: relative;
    z-index: -1;
    .bgImgClass{
    width: 100%;
    height: 100%;
  }

    .headImgClass {
      width: 104px;
      height: 104px;
      border-radius: 50%;
      position: absolute;
      top: 110px;
      left: 248px;
    }

    h4 {
      position: absolute;
      top: 220px;
      width: 100%;
      text-align: center;
    }

    .pBox {
      font-size: 24px;
      line-height: 48px;
      position: absolute;
      top: 330px;
      width: 68%;
      text-align: right;
    }

    .pointClass {
      width: 30px;
      position: absolute;
    }

    .qrClass {
      width: 70px;
      height: 70px;
      position: absolute;
      left: 50px;
      bottom: 50px;
    }
  }
}
</style>
